import React from 'react';
import Screen from '../../Screen';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Scrollable from '../../../elements/Scrollable';

export default class EnrichmentsScreen extends React.Component {
    render() {
        let {i18n, event, enrichmentCategory, currentPosition, maxPosition, returnURL} = this.props,
        counter = (currentPosition && maxPosition && maxPosition > 0)?<div style={{position: 'absolute', right: 0, top: 0}} className='title'>{currentPosition + ' / ' + maxPosition}</div>:null,
        header = <div>
            <TopBarEvent event={event} returnURL={returnURL} >{enrichmentCategory.label }{counter}</TopBarEvent>

            {enrichmentCategory.image_url && <img src={enrichmentCategory.image_url} width="100%"/>}
        </div>;

        return <Screen header={header} footer={this.props.footer}>
            <Scrollable>{this.props.children}</Scrollable></Screen>;
    }
}
